{
	"title": "Créer une déclaration",
	"backLinkToMaterialDetailsTitle": "Retour aux détails du matériau",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Retour à {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Retour à la gestion des déclarations",
	"steps": {
		"firstStep": {
			"title": "Étape 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Étape 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Étape 3",
			"label": "3"
		}
	}
}
